<template>
	<div class="w-full h-full dF fC aS" style="
            display: inline-block;
            border-right: 1px solid rgba(0, 0, 0, 0.1);
        ">
		<LeftNavBar class="f1" :items="sidebarItems" @opened="selectSideBar" :title="selectedAppInitial"
			:selectedValue="sidebarSelection">
		</LeftNavBar>
	</div>
</template>

<script>
	import LeftNavBar from "bh-mod/components/common/LeftNavBar";
	export default {
		components: { LeftNavBar },
		name: "menu-left",
		data() {
			return {
				openID: "",
			};
		},
		computed: {
			selectedAppInitial() {
				return this.$store.state.theApp?.media?.initial || "MA";
			},
			sidebarItems() {
				return [
					{
						label: "Workflows",
						value: "Workflows",
						iconUrl: require("@/assets/workflow.svg"),
						options: [],
						children: [],
					},
					{
						label: "Archived",
						value: "Archived",
						iconUrl: require("@/assets/archived.svg"),
						options: [],
						children: [],
					},
				]
			},
			sidebarSelection() {
				return this.$store.state.sidebarSelection;
			},
		},
		methods: {
			selectSideBar(data) {
				if (this.sidebarSelection != data.value) {
					this.$store.commit("SIDEBAR_SELECTION", data.value);
				}
				if (data.value == "Settings" && this.$route.path !== "/settings") {
					return this.$router.push("/settings");
				} else if (data.value == "Archived" && this.$route.path !== "/archived") {
					return this.$router.push('/archived')
				} if (data.value == "Workflows" && this.$route.path !== "/") {
					this.$router.push('/')
				}
			},
		},
	};
</script>
